import { Graph } from '@square/ignition';
import { ApiExplorerOasContainer } from '@squareup/dex-feature-dex-tech-main-api-explorer-container';
import {
  ApiExplorerRequestContentContainer,
  ApiExplorerResponseContentContainer,
  ApiExplorerSelectorContainer,
} from '@squareup/dex-feature-shared-api-explorer';
import { ReferenceObjectModalProvider } from '@squareup/dex-tech-reference-properties';
import {
  ApiExplorerContentLayout,
  ApiExplorerErrorPageLayout,
  ApiExplorerRequestResponseAsideLayout,
} from '@squareup/dex-ui-shared-api-explorer-page-layout';
import { StatusAndMessage } from '@squareup/dex-utils-error';
import React, { FC, PropsWithChildren, useCallback } from 'react';

const strings = {
  notFound: {
    title: 'Endpoint not found!',
    message:
      'Double-check that this is a correct URL. If that doesn’t work, you can try selecting a valid endpoint.',
  },
  unhandled: {
    title: 'An error occurred!',
    message:
      'An error occurred while trying to fetch the endpoint. Please try again later.',
  },
};

interface Props {
  graph?: Graph | undefined;
  error: StatusAndMessage;
}

const ExplorerErrorPage: FC<Props> = ({ graph, error }) => {
  const OasContainer = useCallback<FC<PropsWithChildren>>(
    ({ children }) => {
      if (!graph) {
        return children;
      }

      return (
        <ApiExplorerOasContainer
          graph={graph}
          endpoint={undefined}
          api={undefined}
        >
          {children}
        </ApiExplorerOasContainer>
      );
    },
    [graph]
  );

  const errorType: keyof typeof strings =
    error.statusCode === 404 ? 'notFound' : 'unhandled';

  return (
    <ReferenceObjectModalProvider>
      <OasContainer>
        <ApiExplorerContentLayout
          apiSelectors={graph ? <ApiExplorerSelectorContainer /> : null}
          fieldContent={
            <ApiExplorerErrorPageLayout
              title={strings[errorType].title}
              description={strings[errorType].message}
              showHomeButton={!graph || errorType === 'unhandled'}
            />
          }
          requestResponseContent={
            <ApiExplorerRequestResponseAsideLayout
              requestContent={<ApiExplorerRequestContentContainer />}
              responseContent={<ApiExplorerResponseContentContainer />}
            />
          }
        />
      </OasContainer>
    </ReferenceObjectModalProvider>
  );
};

export { ExplorerErrorPage };
